import { Seo } from "@/components/Seo";
import { ExportSection } from "@/components/ExportSection";
import { Quality } from "@/components/Sections";
import { useLang } from "@/i18n";

export default function QualityPage() {
  const { t } = useLang();
  return (
    <>
      <Seo title={t.seo.quality.title} description={t.seo.quality.description} path="/quality" />
      <ExportSection h1 heading={t.quality.pageHeading} />
      <Quality />
    </>
  );
}
